import { render, staticRenderFns } from "./PartsProperty.vue?vue&type=template&id=b0bbba5e&"
import script from "./PartsProperty.vue?vue&type=script&lang=ts&"
export * from "./PartsProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports